import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultPRD3012_R01LotDto, defaultPRD3012_R01HeaderDto, defaultPRD3012_R01InspectDto, PRD3012_R01LotDto, PRD3012_R01HeaderDto, PRD3012_R01InspectDto, PRD3012_R01DetailDto, defaultPRD3012_R01DetailDto } from './Dto_PRD3012_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { WareHouseDto } from 'src/dtos/warehouse/wareHouseDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { calculateTotalOrderQty } from 'src/components/common/common';


export interface PRD3012_R01Filter {
	dateRange: DateRange | undefined;
	compCd: string;
	compNm: string;
	workplaceCd: string;
	itemCd: string;
	itemNm: string;
	workEmp: string;
	workEmpNm: string;
	labelPrintAuto: string;
}

export interface Store_PRD3012_R01 {
	PRD3012_R01Filter: PRD3012_R01Filter;
	PRD3012_R01PastFilter: PRD3012_R01Filter;
	setPRD3012_R01Filter: (filter: Partial<Store_PRD3012_R01['PRD3012_R01Filter']>) => void;
	setPRD3012_R01PastFilter: (filter: Store_PRD3012_R01['PRD3012_R01PastFilter']) => void;
	
	// ====== 생산실적 리스트 및 선택/편집 ======
	PRD3012_R01List: PRD3012_R01HeaderDto[];
	setPRD3012_R01List: (salesList: PRD3012_R01HeaderDto[]) => void;

	editPRD3012_R01: PRD3012_R01HeaderDto | null;
	setEditPRD3012_R01: (editHeader: PRD3012_R01HeaderDto | null) => void;

	selectedPRD3012_R01: PRD3012_R01HeaderDto | undefined;
	setSelectedPRD3012_R01: (data: PRD3012_R01HeaderDto | undefined) => void;
	initSelectedPRD3012_R01: () => void;

	// ====== 생산실적 상세(lot) 데이터 ======
	PRD3012_R01LotList: PRD3012_R01LotDto[];
	setPRD3012_R01LotList: (data: PRD3012_R01LotDto[]) => void;
	insertPRD3012_R01LotList: (data: PRD3012_R01LotDto[], index?: number) => void;
	removePRD3012_R01LotList: (index: number) => void;
	updatePRD3012_R01LotList: (index: number, data: PRD3012_R01LotDto) => void;

	// ====== 선택(lot) 행 선택/삭제 관리 ======
	selectedPRD3012_R01LotList: string[];
	setSelectedPRD3012_R01LotList: (idList: string[]) => void;
	addSelectedPRD3012_R01LotList: (idList: string[]) => void;
	removeSelectedPRD3012_R01LotList: (idList?: string[]) => void;
	initSelectedPRD3012_R01LotList: () => void;

	// ====== 상세(lot) 행 선택/삭제 관리 ======
	deletedPRD3012_R01LotList: string[];
	setDeletedPRD3012_R01LotList: (idList: string[]) => void;
	addDeletedPRD3012_R01LotList: (idList: string[]) => void;
	removeDeletedPRD3012_R01LotList: (idList?: string[]) => void;

	originalPRD3012_R01LotList: PRD3012_R01LotDto[];
	setOriginalPRD3012_R01LotList: (data: PRD3012_R01LotDto[]) => void;

	// ====== 자재출고 상세(디테일) 데이터 ======
	PRD3012_R01DetailList: PRD3012_R01DetailDto[];
	setPRD3012_R01DetailList: (data: PRD3012_R01DetailDto[]) => void;
	insertPRD3012_R01DetailList: (data: PRD3012_R01DetailDto[], index?: number) => void;
	removePRD3012_R01DetailList: (index: number) => void;
	updatePRD3012_R01DetailList: (index: number, data: PRD3012_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedPRD3012_R01DetailList: string[];
	setSelectedPRD3012_R01DetailList: (idList: string[]) => void;
	addSelectedPRD3012_R01DetailList: (idList: string[]) => void;
	removeSelectedPRD3012_R01DetailList: (idList?: string[]) => void;
	initSelectedPRD3012_R01DetailList: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3012_R01DetailList: string[];
	setDeletedPRD3012_R01DetailList: (idList: string[]) => void;
	addDeletedPRD3012_R01DetailList: (idList: string[]) => void;
	removeDeletedPRD3012_R01DetailList: (idList?: string[]) => void;

	originalPRD3012_R01DetailList: PRD3012_R01DetailDto[];
	setOriginalPRD3012_R01DetailList: (data: PRD3012_R01DetailDto[]) => void;

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	PRD3012_R01InspectList: PRD3012_R01InspectDto[];
	setPRD3012_R01InspectList: (data: PRD3012_R01InspectDto[]) => void;
	insertPRD3012_R01InspectList: (data: PRD3012_R01InspectDto[], index?: number) => void;
	removePRD3012_R01InspectList: (index: number) => void;
	updatePRD3012_R01InspectList: (index: number, data: PRD3012_R01InspectDto) => void;

	// ====== 선택(디테일) 불량 행 선택/삭제 관리 ======
	selectedPRD3012_R01InspectList: string[];
	setSelectedPRD3012_R01InspectList: (idList: string[]) => void;
	addSelectedPRD3012_R01InspectList: (idList: string[]) => void;
	removeSelectedPRD3012_R01InspectList: (idList?: string[]) => void;
	initSelectedPRD3012_R01InspectList: () => void;

	// ====== 생산실적 불량 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3012_R01InspectList: string[];
	setDeletedPRD3012_R01InspectList: (idList: string[]) => void;
	addDeletedPRD3012_R01InspectList: (idList: string[]) => void;
	removeDeletedPRD3012_R01InspectList: (idList?: string[]) => void;

	originalPRD3012_R01InspectList: PRD3012_R01InspectDto[];
	setOriginalPRD3012_R01InspectList: (data: PRD3012_R01InspectDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;
	
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	inspectColumnState: ColumnState[] | null;
	setInspectColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;		setDetailFetchTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	lotScrollTop: number | null;
	setLotScrollTop: (top: number | null) => void;
	inspectScrollTop: number | null;
	setInspectScrollTop: (top: number | null) => void;

	notProductResult: boolean;
	setNotProductResult: (notProductResult: boolean) => void;

	modalVisible: boolean;
	setModalVisible: (modalVisible: boolean) => void;
	workTimeModalVisible: boolean;
	setWorkTimeModalVisible: (workTimeModalVisible: boolean) => void;
	workTimeModalType: 'start' | 'end' | null;
	setWorkTimeModalType: (type: 'start' | 'end' | null) => void;
	isDetailMaximized: boolean;
	setIsDetailMaximized: (value: boolean) => void;
	
	//화면의 초기 로드 플래그
	isInitialLoad: boolean;
	setIsInitialLoad: (isInitialLoad: boolean) => void;

	// ====== 초기화 ======
	initPRD3012_R01LotData: () => void;
	initData: () => void;

	// 창고 코드 필터링
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	outWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	badWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;

}

//각 Detail 행의 itemCd가 첫번째인지 검증하고. 첫번째라면 transportQty행에 bomUsingQty를 넣고, 아니라면 0을 넣는다.
export const takeDetailItemIsFirstIndex = (
	detailList: PRD3012_R01DetailDto[]
): number[] => {
	const firstValueIndices: number[] = [];
	const seenItemCds = new Set<string>();

	detailList.forEach((item) => {
		// childItemcd가 존재하고, 이전에 본 적 없는 값이라면
		if (item.childItemcd && !seenItemCds.has(item.childItemcd)) {
			// 방문 기록에 추가
			seenItemCds.add(item.childItemcd);
			// 결과 배열에 해당 행의 valueIndex 추가
			firstValueIndices.push(item.valueIndex);
		}
	});

	return firstValueIndices;
};

export const calculateLotQty = (lotList: PRD3012_R01LotDto[], deletedList: string[]): number => {
	return lotList.reduce((sum, item) => {
		if (deletedList.includes(item.valueIndex.toString())) {
			return sum;
		}
		return sum + (Number(item.lotQty) || 0);
	}, 0);
};

export const calculateBomUsingQty = (
	editPRD3012_R01: PRD3012_R01HeaderDto | null,
	detailItem: PRD3012_R01DetailDto,
): number => {
	if (!editPRD3012_R01) return detailItem.bomUsingQty;

	// ResultInfo 생산량(pendingLotQty)만 기준 — LOT 테이블 총량(productQty)과 분리
	const productQty = Number(editPRD3012_R01.pendingLotQty ?? 0);
	const fixLossqty = (productQty > 0) ? detailItem.fixLossqty || 0 : 0;

	return calculateTotalOrderQty(productQty, detailItem.prntItemQty ?? 1, detailItem.childItemUsage, detailItem.lossPercent, fixLossqty);
};


export const recalculateDetailListWithTransport = (
	detailList: PRD3012_R01DetailDto[],
	editHeader: PRD3012_R01HeaderDto | null,
): PRD3012_R01DetailDto[] => {
	//각 itemCd에 해당하는 수량을 저장하는 곳
	const allocatedQtyMap = new Map<string, number>();

	return detailList.map(item => {
		// 동일한 childItemcd당 하나의 row만 transportQty가 bomUsingQty값과 같게 설정
		const bomUsingQty = calculateBomUsingQty(editHeader, item);
		
		//allocatedQtyMap에서 item.childItemcd의 키에 해당하는 수량을 가져오고, 없으면 0을 가져옴
		const currentAllocated = allocatedQtyMap.get(item.childItemcd) || 0;
		//bomUsingQty와 currentAllocated를 빼서 남은 수량을 계산
		const remainingNeeded = Math.max(0, bomUsingQty - currentAllocated);

		let transportQty = 0;
		if (remainingNeeded > 0) {
			transportQty = Math.min(remainingNeeded, item.lotQty);
		}

		//allocatedQtyMap에 item.childItemcd의 키에 해당하는 수량을 저장, 다음 row의 transportQty 계산에 활용
		allocatedQtyMap.set(item.childItemcd, currentAllocated + transportQty);

		// transportQty가 0보다 크면 무조건 저장 대상(isModified = true)으로 설정
		// 또는 값이 변경되었으면 true
		let isModified = transportQty > 0 || item.transportQty !== transportQty;

		if (transportQty === 0) {
			isModified = false;
		}

		return { ...item, bomUsingQty, transportQty, isModified };
	});
};


const calculateTotalProductQty = (editPRD3012_R01: PRD3012_R01HeaderDto, lotList: PRD3012_R01LotDto[], deletedList: string[]): number => {
	let productQtyFromLot = lotList.reduce((sum, item) => {
		if (deletedList.includes(item.valueIndex.toString())) {
			return sum;
		}
		return sum + (Number(item.lotQty) || 0);
	}, 0);

	// console.log('productQtyFromLot : ', productQtyFromLot);

	const productQty = productQtyFromLot;

	return productQty;
};

export const defaultPRD3012_R01Filter : PRD3012_R01Filter = {
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow()
	},
	compCd: '',
	compNm: '',
	workplaceCd: '',
	itemCd: '',
	itemNm: '',
	workEmp: '',
	workEmpNm: '',
	labelPrintAuto: 'N',
};


const getInitialPRD3012_R01HeaderDto = (): PRD3012_R01HeaderDto => {
	const { compCdList, workPlaceList, wmsCdList, warehouseCdList, itemStatusList } = useCommonCodeStore.getState();

	const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
    
    const warehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.productYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const outWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.materialYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const badWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && value.badYn === 'Y'
    ));

	return {
		...defaultPRD3012_R01HeaderDto,
		compCd: compCdList?.[0]?.compCd || '',
		workplaceCd: workPlaceList?.[0]?.workplaceCd || '',
		logicCenter: defaultLogicCenter,
        warehouseCd: warehouseCdListToUse?.[0]?.warehouseCd || '',
        outWarehouseCd: outWarehouseCdListToUse?.[0]?.warehouseCd || '',
        badWarehouseCd: badWarehouseCdListToUse?.[0]?.warehouseCd || '',
        itemStatus: itemStatusList?.[0]?.minorCd || '',
		itemCd: '',
		itemNm: '',
	}
};


export const usePRD3012_R01Store = create<Store_PRD3012_R01>((set, get) => ({
	PRD3012_R01Filter: defaultPRD3012_R01Filter,
	PRD3012_R01PastFilter: defaultPRD3012_R01Filter,
	setPRD3012_R01Filter: (update) => set((state) => ({
		PRD3012_R01Filter: {
			...state.PRD3012_R01Filter,
			...update
		}
	})),
	setPRD3012_R01PastFilter: (filter: Store_PRD3012_R01['PRD3012_R01PastFilter']) => set((state) => {
		return {
			...state,
			PRD3012_R01PastFilter: filter
		}
	}),

	// ====== 생산실적 리스트 및 선택/편집 ======
	PRD3012_R01List: [],
	setPRD3012_R01List: (salesList: PRD3012_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PRD3012_R01List: salesList
		}
	}),

	editPRD3012_R01: getInitialPRD3012_R01HeaderDto(),
	setEditPRD3012_R01: (editHeader: PRD3012_R01HeaderDto | null) => set((state) => {
		const pendingLotQtyChanged = editHeader != null
			&& state.editPRD3012_R01?.pendingLotQty !== editHeader.pendingLotQty;

		const newDetailList = pendingLotQtyChanged && editHeader != null
			? recalculateDetailListWithTransport(state.PRD3012_R01DetailList, editHeader)
			: state.PRD3012_R01DetailList;

		return {
			...state,
			editPRD3012_R01: editHeader,
			PRD3012_R01DetailList: newDetailList,
		}
	}),

	selectedPRD3012_R01: undefined,

	setSelectedPRD3012_R01: (data: PRD3012_R01HeaderDto | undefined) => set((state) => {
		return {
			selectedPRD3012_R01: data,
			selectedPRD3012_R01LotList: [], deletedPRD3012_R01LotList: [],
			selectedPRD3012_R01DetailList: [], deletedPRD3012_R01DetailList: [],
			selectedPRD3012_R01InspectList: [], deletedPRD3012_R01InspectList: [],
			detailFetchTrigger: data != null,
			detailScrollTop: null,
			lotScrollTop: null,
			inspectScrollTop: null,
		};
	}),
	initSelectedPRD3012_R01: () => {
		set({
			selectedPRD3012_R01: undefined,
			editPRD3012_R01: getInitialPRD3012_R01HeaderDto(),
			PRD3012_R01LotList: [],
			detailFetchTrigger: false,
		});
	},

	// ====== 생산실적 상세(디테일) 데이터 ======
	PRD3012_R01LotList: [],
	setPRD3012_R01LotList: (data: PRD3012_R01LotDto[]) => set((state) => {
		let newList: PRD3012_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPRD3012_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PRD3012_R01LotList: newList,
		}
	}),
	insertPRD3012_R01LotList: (data: PRD3012_R01LotDto[], index?: number) => set((state) => {
		let newPRD3012_R01LotList = [...state.PRD3012_R01LotList];
		let maxValueIndex = Math.max(0, ...newPRD3012_R01LotList.map(item => item.valueIndex || 0)) + 1;

		// index가 없으면 맨 마지막에 추가
		if (index === undefined) {
			const maxOrderIndex = Math.max(0, ...newPRD3012_R01LotList.map(item => item.orderIndex || 0)) + 1;
			const newData = data.map(item => ({ ...defaultPRD3012_R01LotDto, ...item,
				valueIndex: maxValueIndex++,
				orderIndex: maxOrderIndex,
				orderIndexSeq: 1
			}));
			newPRD3012_R01LotList.push(...newData);

			return {
				...state,
				PRD3012_R01LotList: newPRD3012_R01LotList,
			}
		}

		let targetRowData = newPRD3012_R01LotList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newPRD3012_R01LotList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newPRD3012_R01LotList = newPRD3012_R01LotList.filter(item => item.orderIndex !== targetOrderIndex);
		newPRD3012_R01LotList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultPRD3012_R01LotDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		newPRD3012_R01LotList.splice(index, 0, ...newData);

		return {
			...state,
			PRD3012_R01LotList: newPRD3012_R01LotList,
		}
	}),
	removePRD3012_R01LotList: (index: number) => set((state) => {
		const newPRD3012_R01LotList = [...state.PRD3012_R01LotList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PRD3012_R01LotList: newPRD3012_R01LotList,
		}
	}),
	updatePRD3012_R01LotList: (valueIndex: number, data: PRD3012_R01LotDto) => set((state) => {
		const _PRD3012_R01LotList = state.PRD3012_R01LotList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.lotQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.lotQty = 0;
		}
		return {
			...state,
			PRD3012_R01LotList: _PRD3012_R01LotList,
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3012_R01LotList: [],
	setDeletedPRD3012_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPRD3012_R01LotList: idList
		}
	}),
	addDeletedPRD3012_R01LotList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedPRD3012_R01LotList];

		for(const valueIndex of idList) {
			const isInserted = state.PRD3012_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PRD3012_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		return {
			...state,
			deletedPRD3012_R01LotList: _deletedLotList,
		}
	}),
	removeDeletedPRD3012_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPRD3012_R01LotList: [...state.deletedPRD3012_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPRD3012_R01LotList: [],
	setSelectedPRD3012_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPRD3012_R01LotList: idList,
		}
	}),
	addSelectedPRD3012_R01LotList: (idList: string[]) => set((state) => {
		const _selectedPRD3012_R01LotList = [...state.selectedPRD3012_R01LotList];
		if(idList.length > 0) {
			_selectedPRD3012_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedPRD3012_R01LotList: _selectedPRD3012_R01LotList
		}
	}),
	removeSelectedPRD3012_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPRD3012_R01LotList: [...state.selectedPRD3012_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPRD3012_R01LotList: () => set({ selectedPRD3012_R01LotList: [] }),	

	originalPRD3012_R01LotList: [],
	setOriginalPRD3012_R01LotList: (data: PRD3012_R01LotDto[]) => set((state) => {
		let newList: PRD3012_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPRD3012_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPRD3012_R01LotList: newList
		}
	}),

	// ====== 자재출고 상세(디테일) 데이터 ======
	PRD3012_R01DetailList: [],
	setPRD3012_R01DetailList: (data: PRD3012_R01DetailDto[]) => set((state) => {
		let newList: PRD3012_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPRD3012_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PRD3012_R01DetailList: newList
		}
	}),
	insertPRD3012_R01DetailList: (data: PRD3012_R01DetailDto[], index?: number) => set((state) => {
		let newPRD3012_R01DetailList = [...state.PRD3012_R01DetailList];

		let targetRowData = newPRD3012_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newPRD3012_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newPRD3012_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newPRD3012_R01DetailList = newPRD3012_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newPRD3012_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultPRD3012_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newPRD3012_R01DetailList.splice(index, 0, ...newData);
		} else {
			newPRD3012_R01DetailList.push(...newData);
		}

		return {
			...state,
			PRD3012_R01DetailList: newPRD3012_R01DetailList
		}
	}),
	removePRD3012_R01DetailList: (index: number) => set((state) => {
		const newPRD3012_R01DetailList = [...state.PRD3012_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PRD3012_R01DetailList: newPRD3012_R01DetailList
		}
	}),
	updatePRD3012_R01DetailList: (valueIndex: number, data: PRD3012_R01DetailDto) => set((state) => {
		const _PRD3012_R01DetailList = state.PRD3012_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? { ...data, isModified: true } : item
		);

		if(data.transportQty < 0) {
			showWarning('출고량은 0보다 작을 수 없습니다.');
			data.transportQty = 0;
		}
		return {
			...state,
			PRD3012_R01DetailList: _PRD3012_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3012_R01DetailList: [],
	setDeletedPRD3012_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPRD3012_R01DetailList: idList
		}
	}),
	addDeletedPRD3012_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedPRD3012_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.PRD3012_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PRD3012_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPRD3012_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedPRD3012_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPRD3012_R01DetailList: [...state.deletedPRD3012_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPRD3012_R01DetailList: [],
	setSelectedPRD3012_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPRD3012_R01DetailList: idList
		}
	}),
	addSelectedPRD3012_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedPRD3012_R01DetailList = [...state.selectedPRD3012_R01DetailList];
		if(idList.length > 0) {
			_selectedPRD3012_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedPRD3012_R01DetailList: _selectedPRD3012_R01DetailList
		}
	}),
	removeSelectedPRD3012_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPRD3012_R01DetailList: [...state.selectedPRD3012_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPRD3012_R01DetailList: () => set({ selectedPRD3012_R01DetailList: [] }),	

	originalPRD3012_R01DetailList: [],
	setOriginalPRD3012_R01DetailList: (data: PRD3012_R01DetailDto[]) => set((state) => {
		let newList: PRD3012_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPRD3012_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPRD3012_R01DetailList: newList
		}
	}),

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	PRD3012_R01InspectList: [],
	setPRD3012_R01InspectList: (data: PRD3012_R01InspectDto[]) => set((state) => {
		let newList: PRD3012_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPRD3012_R01InspectDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PRD3012_R01InspectList: newList
		}
	}),
	insertPRD3012_R01InspectList: (data: PRD3012_R01InspectDto[], index?: number) => set((state) => {
		const newPRD3012_R01InspectList = [...state.PRD3012_R01InspectList];

		//let valueIndex = newSYS4100_R01List.length + 1;
		let valueIndex = Math.max(0, ...newPRD3012_R01InspectList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같은 orderIndex를 가진 행들 중에서 가장 큰 orderIndexSeq 값을 찾는다.
		const maxOrderIndexSeq = Math.max(0, ...newPRD3012_R01InspectList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('newPRD3012_R01InspectList : ', newPRD3012_R01InspectList);
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
		const newData = data.map(item => ({ ...defaultPRD3012_R01InspectDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
			newPRD3012_R01InspectList.splice(index, 0, ...newData);
		} else {
			newPRD3012_R01InspectList.push(...newData);
		}
		return {
			...state,
			PRD3012_R01InspectList: newPRD3012_R01InspectList
		}
	}),
	removePRD3012_R01InspectList: (index: number) => set((state) => {
		const newPRD3012_R01InspectList = [...state.PRD3012_R01InspectList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PRD3012_R01InspectList: newPRD3012_R01InspectList
		}
	}),
	updatePRD3012_R01InspectList: (valueIndex: number, data: PRD3012_R01InspectDto) => set((state) => ({
		...state,
		PRD3012_R01InspectList: state.PRD3012_R01InspectList.map(item =>
			item.valueIndex === valueIndex ? data : item
		),
	})),

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3012_R01InspectList: [],
	setDeletedPRD3012_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPRD3012_R01InspectList: idList
		}
	}),
	addDeletedPRD3012_R01InspectList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedPRD3012_R01InspectList];

		for(const valueIndex of idList) {
			const isInserted = state.PRD3012_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PRD3012_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPRD3012_R01InspectList: _deletedLotList
		}
	}),
	removeDeletedPRD3012_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPRD3012_R01InspectList: [...state.deletedPRD3012_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPRD3012_R01InspectList: [],
	setSelectedPRD3012_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPRD3012_R01InspectList: idList
		}
	}),
	addSelectedPRD3012_R01InspectList: (idList: string[]) => set((state) => {
		const _selectedPRD3012_R01InspectList = [...state.selectedPRD3012_R01InspectList];
		if(idList.length > 0) {
			_selectedPRD3012_R01InspectList.push(...idList);
		}
		return {
			...state,
			selectedPRD3012_R01InspectList: _selectedPRD3012_R01InspectList
		}
	}),
	removeSelectedPRD3012_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPRD3012_R01InspectList: [...state.selectedPRD3012_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPRD3012_R01InspectList: () => set({ selectedPRD3012_R01InspectList: [] }),

	originalPRD3012_R01InspectList: [],
	setOriginalPRD3012_R01InspectList: (data: PRD3012_R01InspectDto[]) => set((state) => {
		let newList: PRD3012_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPRD3012_R01InspectDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPRD3012_R01InspectList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),

	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	inspectColumnState: null,
	setInspectColumnState: (state: ColumnState[] | null) => set({ inspectColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	lotScrollTop: null,
	setLotScrollTop: (top: number | null) => set({ lotScrollTop: top }),
	inspectScrollTop: null,
	setInspectScrollTop: (top: number | null) => set({ inspectScrollTop: top }),

	notProductResult: true,
	setNotProductResult: (notProductResult: boolean) => set({ notProductResult }),

	modalVisible: false,
	setModalVisible: (modalVisible: boolean) => set({ modalVisible }),

	workTimeModalVisible: false,
	setWorkTimeModalVisible: (workTimeModalVisible: boolean) => set({ workTimeModalVisible }),

	workTimeModalType: null,
	setWorkTimeModalType: (workTimeModalType: 'start' | 'end' | null) => set({ workTimeModalType }),

	isDetailMaximized: false,
	setIsDetailMaximized: (value: boolean) => set({ isDetailMaximized: value }),

	isInitialLoad: true,
	setIsInitialLoad: (isInitialLoad: boolean) => set({ isInitialLoad }),

	initPRD3012_R01LotData: () => set((state) => {
		const nextEdit = state.editPRD3012_R01 ? {
			...state.editPRD3012_R01,
			pendingLotQty: 0,
		} : state.editPRD3012_R01;

		return {
			PRD3012_R01LotList: [],
			deletedPRD3012_R01LotList: [],
			selectedPRD3012_R01LotList: [],
			originalPRD3012_R01LotList: [],
			editPRD3012_R01: nextEdit,
			PRD3012_R01DetailList: recalculateDetailListWithTransport(
				state.PRD3012_R01DetailList,
				nextEdit,
			),
		};
	}),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		PRD3012_R01Filter: defaultPRD3012_R01Filter,
		PRD3012_R01PastFilter: defaultPRD3012_R01Filter,
		PRD3012_R01List: [],
		selectedPRD3012_R01: undefined,
		editPRD3012_R01: getInitialPRD3012_R01HeaderDto(),

		PRD3012_R01LotList: [],
		deletedPRD3012_R01LotList: [],
		selectedPRD3012_R01LotList: [],
		originalPRD3012_R01LotList: [],

		PRD3012_R01DetailList: [],
		deletedPRD3012_R01DetailList: [],
		selectedPRD3012_R01DetailList: [],
		originalPRD3012_R01DetailList: [],

		PRD3012_R01InspectList: [],
		deletedPRD3012_R01InspectList: [],
		selectedPRD3012_R01InspectList: [],
		originalPRD3012_R01InspectList: [],

		allCount: 0,
		detailFetchTrigger: false,
		isInitialLoad: true,
		notProductResult: true,
		modalVisible: false,
		workTimeModalVisible: false,
		workTimeModalType: null,
		isDetailMaximized: false,
		scrollTop: null,
		detailScrollTop: null,
		lotScrollTop: null,
		inspectScrollTop: null,
	})),

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.goodsYn === 'Y' || value.productYn === 'Y')
		));
	},
	outWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.manufactYn === 'Y')
		));
	},
	badWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		));
	},

	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => {
		const { compCdList, workPlaceList, wmsCdList, itemStatusList } = useCommonCodeStore.getState();
		const state = get();
		
		if (compCdList.length === 0) return;

		const defaultCompCd = compCdList?.[0]?.compCd || '';
		const defaultWorkplaceCd = workPlaceList?.[0]?.workplaceCd || '';
		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		const defaultItemStatus = itemStatusList?.[0]?.minorCd || '';

		const warehouseCdListToUse = state.warehouseCdListToUseList(defaultLogicCenter);
		const outWarehouseCdListToUse = state.outWarehouseCdListToUseList(defaultLogicCenter);
		const badWarehouseCdListToUse = state.badWarehouseCdListToUseList(defaultLogicCenter);

		const defaultWarehouseCd = warehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultOutWarehouseCd = outWarehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultBadWarehouseCd = badWarehouseCdListToUse?.[0]?.warehouseCd || '';

		let newFilter = state.PRD3012_R01Filter;
		let newEditHeader = state.editPRD3012_R01;
		let needUpdate = false;

		if (state.editPRD3012_R01 && (!state.editPRD3012_R01.compCd || !state.editPRD3012_R01.logicCenter)) {
			newEditHeader = {
				...state.editPRD3012_R01,
				compCd: defaultCompCd,
				workplaceCd: defaultWorkplaceCd,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				outWarehouseCd: defaultOutWarehouseCd,
				badWarehouseCd: defaultBadWarehouseCd,
				itemStatus: defaultItemStatus,
			};
			needUpdate = true;
		}

		if (needUpdate) {
			set({
				editPRD3012_R01: newEditHeader
			});
		}
	},

	
}));
